var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buffer-container"},[_c('el-button',{attrs:{"id":"buffer-button","type":"primary","icon":"el-icon-connection"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.$t('mensagens.menuMapa.labels.analisarProximidades')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }